module.exports = __webpack_public_path__ + "img/misc_help.45d4de0a.svg";